import { Controller } from 'stimulus'

export default class extends Controller {
  connect () {
    initSubmitFormsWithCtrlEnter();
    $('#chat_message_content').trigger('focus');
    super.connect()
  }
}
